<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card class="dashboard-welcome-card">
          <md-card-header data-background-color="blue">
            <h4 class="title">
              Bienvenid@, {{ (delegateData && delegateData.name) || (isPresident ? "Presidente" : "Delegado") }}
            </h4>
            <p class="category">
              Comisión: <strong>{{ (commissionData && commissionData.name) || "Comisión" }}</strong>
            </p>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-100 banner-container" v-if="commissionData && commissionData.bannerURL">
                <img :src="commissionData.bannerURL" alt="Banner Comisión" class="commission-banner">
              </div>

              <div class="md-layout-item md-size-100 info-section">
                <h3 class="section-title">
                  <i class="fas fa-gavel"></i> Sistema de Control de Evidencias (SICE)
                </h3>
                <p class="section-description">
                  Panel centralizado para la administración documental y valoración jurídica. 
                  Utiliza las herramientas laterales para gestionar tus archivos y revisar el estado de las evidencias.
                </p>

                <div class="md-layout feature-grid">
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <div class="feature-item">
                      <i class="far fa-file-lines feature-icon"></i>
                      <h4>Archivos</h4>
                      <p>Sube y organiza documentos de trabajo de forma segura.</p>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <div class="feature-item">
                      <i class="fas fa-clipboard-check feature-icon"></i>
                      <h4>Evidencias</h4>
                      <p>Consulta el veredicto y las notas jurídicas de cada prueba.</p>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <div class="feature-item">
                      <i class="far fa-bell feature-icon"></i>
                      <h4>Alertas</h4>
                      <p>Seguimiento de cambios y comentarios en tiempo real.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { clearAuthContext } from "@/authContext";

export default {

  created() {
    this.$loadDelegateProfile();
  },
  data() {
    return {
      dailySalesChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      dataCompletedTasksChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },

        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      emailsSubscriptionChart: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De",
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
          ],
        },
        options: {
          axisX: {
            showGrid: false,
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
    };
  },
  computed: {
    authContext() {
      return (
        this.$delegateStore.state.authContext || {
          cohort: "",
          commissionId: "",
          delegateId: "",
        }
      );
    },
    isPresident() {
      return this.authContext.role === "president";
    },
    delegateData() {
      return this.$delegateStore.state.delegateData;
    },
    commissionData() {
      return this.$delegateStore.state.commissionData;
    },
    delegateLoading() {
      return this.$delegateStore.state.delegateLoading;
    },
    delegateError() {
      return this.$delegateStore.state.delegateError;
    },
  },
  methods: {
    loadDelegateData() {
      this.$loadDelegateProfile({ force: true });
    },
    changeAuthContext() {
      clearAuthContext();
      this.$delegateStore.resetDelegateState();
      this.$router.replace("/auth");
    },
  },
};
</script>

<style scoped>
.dashboard-welcome-card {
  margin-top: 10px;
}

.banner-container {
  margin-bottom: 24px;
}

.commission-banner {
  width: 100%;
  max-height: 280px;
  object-fit: cover;
  border: 1px solid #e2e8f0;
  border-radius: 0;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #23233a;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-description {
  color: #64748b;
  font-size: 15px;
  line-height: 1.5;
  max-width: 800px;
}

.feature-grid {
  margin-top: 32px;
}

.feature-item {
  background: #f8fafc;
  padding: 24px;
  border: 1px solid #e2e8f0;
  text-align: center;
  height: 100%;
  border-radius: 0;
}

.feature-icon {
  font-size: 24px;
  color: #23233a;
  margin-bottom: 16px;
  display: block;
}

.feature-item h4 {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.feature-item p {
  font-size: 12px;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
}

.title {
  font-weight: 600;
}
</style>
